import { THEME } from 'configurations/appConfig';

export const bootstrap = THEME.bootstrap;
export const logo = THEME.logo;
export const logo_light = THEME.logo_light;
export const login_image = THEME.login_image;
export const favicon = THEME.favicon;
